
/**
 * Simple functional component to replace non existing content <template> tag when used inside components
 */
export default {
  functional: true,
  render(h, ctx) {
    return ctx.children;
  }
};
